import { render, staticRenderFns } from "./MobileAdminCollapseTab.vue?vue&type=template&id=9003fde8&scoped=true"
import script from "./MobileAdminCollapseTab.vue?vue&type=script&lang=js"
export * from "./MobileAdminCollapseTab.vue?vue&type=script&lang=js"
import style0 from "./MobileAdminCollapseTab.vue?vue&type=style&index=0&id=9003fde8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9003fde8",
  null
  
)

export default component.exports